import React from 'react';
import { Link } from 'react-router-dom';
import { bestSellerProducts } from '../data/mockData';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { ArrowRight } from 'lucide-react';

const BestSellers = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="bg-purple-600/20 text-purple-400 border-purple-500/30 mb-4">
            Best Seller
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Best Seller Products
          </h2>
          <p className="text-gray-400 text-lg">
            Products that are loved by our customers
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {bestSellerProducts.map((product) => (
            <Link key={product.id} to={`/product/${product.id}`}>
              <Card 
                className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-white/10 hover:border-purple-500/50 transition-all duration-300 group cursor-pointer overflow-hidden"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                </div>
                <CardContent className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {product.name}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4 line-clamp-2">{product.description}</p>
                  <div className="flex items-center justify-between mt-4">
                    <div>
                      <p className="text-gray-400 text-sm">Starting at</p>
                      <p className="text-2xl font-bold text-purple-400">${product.variants[0].price.toFixed(2)}</p>
                    </div>
                    <Button className="bg-purple-600 hover:bg-purple-700 text-white group">
                      View
                      <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <Link to="/products">
            <Button variant="outline" className="border-white/20 text-white hover:bg-white/10 px-8 py-6 text-lg group">
              View All Products
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </Link>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl" />
    </section>
  );
};

export default BestSellers;
